<template>
    <div class="main-cn">
        <div class="main-hd">
            <h4>我的任务</h4>
        </div>
        <div class="main-bd mg20">
            <el-tabs v-model="active_name" @tab-click="handleSwitch">
                <el-tab-pane label="我执行的" name="MyTask"></el-tab-pane>
                <el-tab-pane label="我创建的" name="MyCreated"></el-tab-pane>
            </el-tabs>
            <el-row class="searchSection" >
                <SearchForm 
                :params="searcheModel" 
                :fields="fields" 
                :cache_field="'search_config_' + active_name + '_' + this.$route.path" 
                @search="submitSearch" 
                @reset="resetForm" 
                :key="search_form_key"> 
                </SearchForm>
            </el-row>
            <el-row class="addBtn" >
                <el-button type="success" size="small" @click="createTask">创建任务</el-button>
                <ExportFile 
                    :url="'/api/export/task-list'" 
                    :params="searcheModel" 
                    filename="我的任务" 
                    buttonName="导出Excel">
                </ExportFile>
            </el-row>
            
            <task-list v-if="tasks" :tab-name="active_name" :loading="loading" :tasks="tasks" @refreshTasks="refreshTasks"></task-list>
            <el-row v-if="linkPage">
                <pagination :linkPage="linkPage"></pagination>
            </el-row>

            <!-- 创建任务表单 -->
            <task-form v-if="showForm" :taskModel="taskModel" @changeShow="changeShow" @saveCallback="saveCallback">
            </task-form>
            <!-- 创建任务表单EOF -->

        </div>

    </div>
</template>


<script>
import Pagination from "~/widgets/Pagination.vue";
import TaskService from "~/services/task";
import TaskList from "~/views/tasks/list.vue";
import TaskForm from "~/views/tasks/form.vue";
import SearchForm from "~/widgets/SearchForm.vue";
import ExportFile from "~/widgets/ExportFile.vue";

export default {
    components: {
        TaskList,
        Pagination,
        TaskForm,
        SearchForm,
        ExportFile
    },
    data() {
        return {
            loading: false,
            active_name: "MyTask",
            tasks: [], //任务列表
            linkPage: null,
            showForm: false,
            taskModel: {},
            searcheModel: {},
            fields: [],
            search_form_key: 0
        };
    },

    // 监听路由参数更新执行分页请求
    beforeRouteUpdate: function(to, from, next) {

        let params = { page: to.query["page"], perPage: to.query["perPage"] };
        let userId = this.$store.getters.userId;

        switch (this.active_name) {
            case "MyTask":
                params.executor_id = userId;
                break;
            case "MyCreated":
                params.creator_id = userId;
                break;
        }

        this.getTaskList(params);
    },

    mounted: function() {
    },

    created: function () {
        this.resetForm();
    },

    methods: {
        //重置按钮
        resetForm() {
            this.searcheModel = {};
            switch (this.active_name) {
                case "MyTask":
                    this.searcheModel['executor_id'] = this.$store.getters.userId;
                    break;
                case "MyCreated":
                    this.searcheModel['creator_id'] = this.$store.getters.userId;
                    break;
            }
            this.fields = TaskService.getFields(this.$route.path, this.active_name);
            this.search_form_key ++;
            this.submitSearch();
        },

        // 筛选查询
        submitSearch(params = null) {
            if(params){
                this.searcheModel = params;
            }
            params = _.clone(this.searcheModel);
            _.each(params, (val, key) => {
                // 如果值是假值，除了数字 0 和字符串 '0'，都删除该键
                if (val === undefined || val === null || (typeof val === 'string' && val === '')) {
                    delete params[key];
                }
            })
            this.list = [];
            this.getTaskList(params);
        },

        getTaskList(params = {}) {
            this.loading = true;
            TaskService.getTaskList(params).then(res => {
                if (res && res.data) {
                    this.tasks = res.data;
                    if (res._meta) {
                        this.linkPage = res._meta;
                    }
                }
                this.loading = false;
            }).catch(err => {
                console.error(err);
            });
        },

        // 处理 Tab 切换逻辑
        handleSwitch(tab, event) {
            this.resetForm()
        },

        createTask() {
            this.showForm = true;
            this.taskModel = Object.assign({}, TaskService.getModel());
        },

        // form dialog 的回调
        changeShow(isShow) {
            this.showForm = isShow;
        },

        // 当表单表单提交保存后的回调
        saveCallback(task) {
            this.submitSearch();
        },

        refreshTasks() {
            this.submitSearch();
        }
    }
};
</script>


// WEBPACK FOOTER //
// src/views/tasks/index.vue